import { render, staticRenderFns } from "./ubc2026ElectrochemReportSheetC.vue?vue&type=template&id=5355fe56&scoped=true&"
import script from "./ubc2026ElectrochemReportSheetC.vue?vue&type=script&lang=js&"
export * from "./ubc2026ElectrochemReportSheetC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5355fe56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
